import landing from "./landing";
import auth from "./auth";
import balance from "./balance";
import catalog from "./catalog";
import clients from "./clients";
import documents from "./documents";
import employee from "./employee";
import files from "./files";
import history from "./history";
import organization from "./organization";
import registration from "./registration";
import shop from "./shop";
import tariff from "./tariff";
import wallet from "./wallet";

export default {
  auth,
  balance,
  catalog,
  clients,
  documents,
  employee,
  files,
  history,
  organization,
  registration,
  shop,
  tariff,
  wallet,
  landing,

  //SYSTEM
  sys: {
    error: "Error:",
    descError: "Description:",
    wrongLogin: "Incorrect login",
    wrongPass: "Incorrect password",
    unknown: "Unknown",
    unauthenticated: "Not authenticated",
    iikAlready: "A legal entity with this IIC already exists",
    noMoney: "Insufficient funds on the balance",
    wrongPeriod: "ProPlus is only available for a year",
    noPermissions: "The user does not have the necessary permissions.",
    firstLoginManager: "First login detected, please create a password",
    limitShops: "Creating a store is limited by your plan",
    limitLegalEntity: "Creating a legal entity is limited by your plan",
    wrongTariff: "This feature is not available on your plan",
    wrongTariffPromo: "The promo code is not valid for registration",
    tagExist: "This tag already exists",
    503: "Server unavailable",
    blockManager: "Manager is blocked",
    wrongCode: "Incorrect code",
    codeExists: "Partner promo code entered incorrectly",
    noExam: "Exam not passed",
    noActivateAccount: "Account not activated",
    emailExist:
      "An owner with this email is already registered in RC GROUP services",
    userExist:
      "An owner with this email is already registered in RC GROUP services",
    noAccepted: "New agreement not accepted",
    balanceNotEnough: "Insufficient balance",
    innExist: "A legal entity with this TIN already exists",
    noTodayChangeTariff:
      "You can change your plan only one day before the current plan ends",
    badToken: "This link is invalid",
    wrongEmail: "Invalid email",
    emailTaken: "Email address already taken",
    notAvailableCurrentTariff: "Not available on the current plan",
    dataNoCorrect: "Incorrect data",
    accountNotFound: "Account not found",
    TPExist: "Point of sale already exists",
    serverError: "Server error",
    ownerExist: "Account not found",
    unauthorizedAction: "You do not have enough rights",
    legalEntityExist: "Legal entity not found",
    tariffChangeOneDay:
      "The plan can be changed one day before the current one ends",
    blockedByTariff: "Blocked due to plan restrictions",
    documentInProcessOfCreation: "Document is being generated",
    emailAlreadyVerified: "Your email has already been verified!",
    emailConfirmed: "Your email has been successfully verified!",
    codeDoesNotExist: "The entered code is invalid",
    defaultCashbackCanNotBeDeleted:
      "Reward for clients without a branded card cannot be deleted",
    cashbackUpdateSuccessful: "Cashback percentage updated successfully",
    cashbackDeleteSuccessful: "Cashback deleted",
    cashbackCreateSuccessful: "Cashback created",
    fullCashback: "Client without a branded card",
    clientGroupAlreadyInUse: "Client group is already used in a cashback group",
    enteredAmountIsAlreadyInUse: "The entered cashback amount is already set",
    dateStartIsInvalid: "Start date is invalid",
    dateEndIsInvalid: "End date is invalid",
    organizationNotConfirmed: "Legal entity not verified",
    periodNotAvailable: "Selected period is not available for purchase",
    notAvailableInYourCountry:
      "Selected period is not available in your country",
    exceededActivatedPromotionLimit:
      "Only 3 active promotions per point of sale are allowed",
    tradingPointLimitOnProPlus:
      "On the ProPlus plan, you can create up to 30 points of sale",
    tradingPointLimitOnPromo:
      "On the Promo plan, you can create up to 15 points of sale",
    tradingPointLimitOnLight:
      "On the Light plan, you can create up to 5 points of sale",
    wrongDateOrder: "The start date must be earlier than the end date",
    descriptionFormatInvalid: "Description must not contain hashtags or emojis",
    descriptionMustNotContainEmoji: "Description must not contain emojis",
    descriptionMinLength:
      "Description must be longer than 600 characters (excluding spaces)",
    descriptionMaxLength: "Description must not exceed 3000 characters",
    maxFileSizeError: "File size exceeds the 10 MB limit",
    addFile:
      "Drag or <span style='color: #447ECB; cursor: pointer'>upload files</span>",
    balance: "Balance",
    changeMainOrganizationError:
      "You can change the main organization only 30 days after the previous change",
    resetWallet: "Failed to reset wallet pass design",
    updateWallet: "Failed to update wallet pass design",
    userUnauthorized: "Incorrect login or password",
    noData: "No data",
    kb: "KB",
    dateMask: "dd.mm.yyyy",
    sort: "Sorting",
    noDataTitle: "No data available yet",
    syncError: "Synchronization issue. Please try again later.",
    enterName: "Enter name",
    countries: {
      ru: "Russia",
      kz: "Kazakhstan",
      md: "Moldova",
      ky: "Kyrgyzstan",
      uz: "Uzbekistan",
    },
    select_country: "Select a country",
    country: "Country",
    q_date: {
      days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday",
      daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat",
      months:
        "January_February_March_April_May_June_July_August_September_October_November_December",
      monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec",
    },
    errorTitle: "Something went wrong",
    dateFrom: "Data available from ",
    dateToToday: " to today",
    dateFormat: "Format dd.mm.yyyy or dd.mm.yyyy - dd.mm.yyyy",
    showBy: "Show by:",
    showByMobile: "By:",
    searchResponseEmpty: "No results found for your query",
    search: "Search",
    imageSize: "MB",
    tagSearchResponseEmpty: "Tag not found. Press Enter or Space to add it.",
    from: "From:",
    to: "To:",
    gender: {
      m: "Male",
      f: "Female",
    },
    500: "Something went wrong. Please check your internet connection.",
    soon: "Coming soon!",
    fromToPercent: "From {from} to {to} %",
    fromToDays: "From {from} to {to} days",
    timeFormat: "hh:mm – hh:mm",
    language: "Language",
  },

  message: {
    changesSavedAndSendedToModeration:
      "The changes have been saved and sent for moderation",
  },

  entity: {
    title: "Add organization details",
    thirdStepTitle:
      "Please check the accuracy of the data. Now you need to wait 24 to 48 hours for us to verify your legal entity.",
    accept: "I accept the terms of the agreement",
    offers: "offer",
    titleReject: "Application rejected!",
    rejectDescription:
      "Unfortunately, the information you provided turned out to be incorrect. Please carefully review the response from the moderators and make changes to your organization’s details.",
    message: "Message from moderators:",
    change: "Edit data",
    titleWaiting: "Thank you for registering!",
    descriptionWaiting:
      "Your organization is currently under review. You will be able to access your personal account after we verify the accuracy of your data. Typically, the review takes between 24 and 48 hours.",
    descriptionWaitingRu:
      "<p>Your organization is currently under review.</p> <p>Once we verify the accuracy of your data, you will be able to log in to your RC Group partner account.</p> <p>The review usually takes between 24 and 48 hours.</p>",
    descriptionWaitingRuWithoutPos:
      "<p>Your organization is currently under review.</p> <p>Once we verify the accuracy of your data, you will be able to log in to your RC Group partner account.</p> <p>The review usually takes between 24 and 48 hours.</p>",
    downloadAccept: "Download invoice for payment",
    addDone: "Congratulations on creating your legal entity!",
    waitingApprove:
      "<p>Your legal entity is currently being verified. This process takes between 24 and 48 hours.</p><p>To complete the verification, you must pay the invoice from the specified legal entity by downloading it using the button below. You can also find the invoice in your personal account under “My Enterprises” → “Documents” with the title “Test Payment”.</p>",
  },

  contacts: {
    title: "Contacts",
    subtitle:
      'JOINT-STOCK COMPANY "INFORMATION AND FINANCIAL TECHNOLOGIES CORPORATION" (JSC "Infintech Corporation") Legal address: 191124, <br/>' +
      "Saint Petersburg, Krasnogo Tekstilshchika St., 10-12, lit. O, floor 6, premises 1-N, office 624 <br/> TIN/KPP 7842216564/784201001 OGRN 1237800080616",
    mailAddress: "Email address: ",
  },

  failed: "Error. Action failed",
  success: "Action completed",

  //cabinet layout
  leftPanel: {
    counterparties: "Counterparty Verification",
    entities: "Legal Entities",
    tradingPoint: "Trading Points",
    paymentMethods: "Payment Methods",
    employees: "Cashiers",
    documents: "Documents",
    businesses: "Business",
    tariffs: "Tariffs",
    historyPayment: "Transaction History",
    promotions: "Promotions",
    actsAndAccounts: "Acts and Invoices",
    accrualCashback: "Points Accrual",
    managers: "Managers",
    spread: "RC Card Distribution",
    analytics: "Analytics",
    points: "Cashier Points",
    enterprises: "My Enterprises",
    paymentDecision: "Payment Decision",
    portfolio: "Portfolio",
    employees_and_managers: "My Staff",
    loyalty: "Loyalty Program",
    clients: "Clients",
    claims: "Requests",
    claims_history: "Request History",
    claims_groups: "Client Grouping",
    reviews: "Reviews",
    extendTariff: "Extend Tariff",
    changeTo: "tariff will change to",
    wallet: "Wallet Card Design",
    accountIs: "Logged in as",
    manager: "Manager",
    owner: "Owner",
    terminals: "POS Terminals",
    terminals_MSPOS: "RC Processing 4-in-1",
    terminals_LIMON: "MPOS Technology",
    FAQ: "About RC CITY",
    corporate: "Communication",
    push: "Wallet Push Notifications",
    tips: "Cashless Tips",
    eMenu: "Online Menu",
    documentLaboratory: "Document Lab",
    giftCard: "Gift Cards",
    processing: "Processing",
    services: "Services",
    wallets: "Loyalty Cards",
    clientsList: "Client List",
    marketplaces: "Marketplaces",
    PromotionServices: "Promotion",
    PreOrders: "Orders",
    PWA: "Install App",
    tgNotifications: "Telegram Notifications",
  },
  headerButtons: {
    addCoin: "Top Up",
    profile: "Profile",
    exit: "Logout",
    themLight: "Light Theme",
    themDark: "Dark Theme",
  },

  // Managing managers page
  managers: {
    title: "Managers",
    noManagersError: "You don’t have any managers yet",
    addManager: "Add Manager",
    managerCreated: "Manager Created",
    managerReset: "Manager's password has been reset!",
    oneTimePass: "One-Time Password",
    messageManagerCreated:
      "Attention! Save this password. On the first login, the manager will need to create a new password.",
    changePass:
      "Attention! Save this password. On the first login, the manager will need to create a new password",
    add: {
      title: "Add Manager",
      second_name: "Manager's Last Name",
      first_name: "Manager's First Name",
      patronymic: "Manager's Middle Name",
      position: "Manager's Position",
      phone: "Manager's Phone Number",
      permissions: "Access to Dashboard Pages",
      button: "Create Manager",
    },
    changeTitle: "Edit Manager",
    buttonChange: "Update Manager Info",
    buttonResetPassword: "Reset Password",
    newPassword: "Enter New Password",
    newPassRules1: "Must be at least 8 characters long",
    newPassRules2: "Must contain letters and numbers (Latin alphabet)",
    deleteManager: "Are you sure you want to delete this manager?",
  },

  //check counterparties page
  counterparties: {
    title: "Проверка контрагентов",
    buttonCheck: "Проверить",
    question:
      "Дата регистрации, ИНН, КПП, ОГРН,  Основной вид деятельности, Статус юрлица,ИФНС, Юридический адрес, Ген. директор, Учредители, Уставный капитал",
    instructionButton: "Инструкция для проверки контрагентов",
    listTitle: "Как использовать Бот для проверки контрагентов?",
    listItemFirst:
      "Введите ИНН или ОГРН организации, которую собираетесь проверять.",
    listItemSecond: "Telegram-Бот покажет вам всю необходимую информацию.",
    listItemThird:
      "Для проверки блокированных счетов нужно нажать на кнопку «Проверить блокировку счетов».",
    listItemFourth:
      "После нажатия на кнопку «Проверить блокировку счетов» Бот покажет все заблокированные счета (при их наличии), ФНС, дату блокировки, № постановления, основание  в соответствии со статьей. Данную информацию можно скачать в PDF-формате для подробного изучения: нажмите кнопку «Скачать файл отчетом».",
    instructionCardTitleFirst: "Зачем проверять контрагентов?",
    instructionCardTitleSecond: "Своевременно узнавайте о фактах.",
    instructionCardTextFirst:
      "<p>Проверка контрагентов необходима для оперативного выявления финансовых и налоговых рисков, которые могут возникнуть при работе с контрагентом, и принятия обоснованных решений — продолжить или прекратить сотрудничество. <br> Бот автоматически проверяет новых и текущих контрагентов по разным источникам и сообщает вам о критических факторах и сведениях, требующих внимания.</p>",
    instructionCardTextSecond:
      "<p>С помощью бота вы можете проводить массовую проверку и мониторинг изменений по всей базе контрагентов или по конкретной выделенной. Это позволяет вовремя реагировать на существенные изменения у клиентов и партнеров, снижая риск невозврата денежных средств.</p>",
  },

  // Claims and history claims page
  claims: {
    title: "Claims",
    historytitle: "Claims History",
    group_name: "Group Name",
    group_nomination: "Group Title",
    group_sum: "Purchase Amount (excluding discounts)",
    create_group: "Create New Group",
    edit_group: "Edit Group",
    delete_group: "Are you sure you want to delete this group?",
    sum: "Amount",
    percent: "Accrual Percentage",
    noClients: "You haven’t had any clients yet",
    oneClient: "You only had one client",
  },
  // Reviews page
  review: {
    title: "Отзывы в RC PAY",
    pageHint:
      "Данный подраздел предназначен для сбора обратной связи от посетителей ваших заведений, которая будет размещена на сайте rcpay.ru. Вы можете сами управлять какие отзывы отображать, кликнув на значок «глаз»",
    goodFirst: "Сначала положительные",
    badFirst: "Сначала отрицательные",
    newFirst: "По новизне",
    noTradingPointsData:
      "Для просмотра отзывов, необходимо создать торговую точку",
    hint: "Отзыв зависит от фильтра по датам",
    noReviews: "У вас еще нет отзывов",
    all: "Все отзывы",
    shown: "Отображаемые",
    hidden: "Скрытые",
    hideStatus: "Отзыв будет скрыт со страницы отзывов на сайте rcpay.ru",
    showStatus: "Показать отзыв на странице Вашей торговой точки на rcpay.ru?",
    noDataLabel: "Данных по отзывам нет",
    noTradingPointText: "У вас пока нет Торговых точек ",
    noReview: "Пользователи еще не оставляли отзывы о Вашей торговой точке",
  },

  //analytic page
  analytics: {
    title: "Insights",
    organizationSelect: "Выберите Юр лицо",
    organizationButton: "Юр лица",
    organizationCheckbox: "All entities",
    newOrganizationCheckbox: "Все Юр лица",
    calendar: "Calendar",
    organizations: {
      newClients: "New customers",
      allClients: "All customers",
      sales: "Sales",
      amount: "Amount of sales",
      amountCashback: "Less the amount set off by points",
      average: "Average receipt",
      averageCashback: "Average reward",
    },
    countClients: "Number of customers",
    topSumEmployee: "Top employees by sales amount",
    topSaleEmployee: " Top employees by sales",
    points: "Points",
    addPoints: "Points accrued",
    writePoints: "Points debited",
    rfmAnalysis: "RFM Анализ",
    rfmGroupSizes: "Размер RFM групп",
    clientPortrait: {
      btn: "Портрет клиента",
      title: "Клиенты",
      customerCount: "Количество клиентов:",
      receiptAvg: "Средний чек:",
      receiptCount: "Количество продаж:",
      receiptSum: "Сумма продаж:",
      maleFemale: "М/Ж:",
      noGender: "Пол не указан:",
    },
  },

  // Cashback page
  cashback: {
    title: "Points accrual",
    subTitle:
      "Обратите внимание!<br>Клиенты на тарифе FREE получают 25%,<br> Клиенты на тарифе SMART 50%,<br> Ваши оцифрованные клиенты получают 50%<br> (комиссия не взымается)<br><br>Подробнее с тарифами Вы можете ознакомиться в разделе «Мои предприятия» далее «Тарифы»",
    statusName: "Customers without branded card",
    delay: "Задержка начислений (В днях)",
    setDelay: "Изменить задержку",
    editDelay: "Изменить задержку начислений",
    maxDelay: "Максимальная задержка 14 дней",
    setReward: "Установить вознаграждение",
    selectGroup: "Выберите группу",
    rewardPercent: "Введите процент начисления",
    minReward: "Минимальный процент начисления - 4",
    maxReward: "Максимальный процент начисления - 25",
    delayTitle: "Текущая задержка торговой точки:",
    withoutActiveWait:
      "Ваш пользователь получит вознаграждение в течении 30 минут с момента проведения операции",
  },
  // Spread page
  spread: {
    title: "Распространение карт RC",
    p1: "By scanning this code, your customers will be able to get a card.",
    p2: "We strongly advise to place the table-tent with QR code and caption “Download the Bonus Card! Earn bonus points and enjoy special purchase terms” near the checkout or a place where your customers make payment. E.g., on the tables in a cafe, in the waiting area near the checkout terminal in a store, or in other place so that your customers would see this info.",
    getCard: "Get a card using this link",
    ttl1: "Get a card via RC KASSA",
    p4: "Use RC KASSA app to get your QR code: go to menu and select “issue a Wallet card”. Propose your customer to scan the code using mobile phone. Despite of the ease of card getting in such a way, we advise to print and place QR code and invitation near the checkout terminal.",
    ttl2: "Employee management",
    p5: "The works experience shows that employees often not supportive to implementation of loyalty programs. It relates both to obsolete plastic and digital solutions, such as RC Group. Many employees may feel that while telling the customers on the loyalty program they reduce the company’s revenues. Such thinking is misguiding. The more active the loyalty program, the higher the average bill, the buying frequency, and the brand loyalty. Moreover, expansion of the program helps reduce the business costs for SMS and other mailing and get to know own customers better.",
    coped: "Copied",
  },

  // Push notifications page
  notifications: {
    title: "Push-уведомления",
    modal:
      "Рассылка находится в обработке, Ваши пользователи получат push-уведомление в течение 15 минут",
    description:
      "Внимательно прочитайте текст. После создания уведомления, изменить его будет <span>невозможно.</span>",
    notificationText: "Текст уведомления",
    sendError: "Не удалось отправить Push-уведомление",
    sendTime: "По московскому времени",
    noNotifications: "У вас нет созданных push-уведомлений",
    buttonNoData: "Создать PUSH-сообщение",
    table: {
      shopName: "Название торговой точки",
      header: "Заголовок",
      date: "Дата",
      time: "Время",
    },

    view: {
      shop: "Торговая точка",
      header: "Заголовок",
      message: "Текст сообщения",
      date: "Дата",
      time: "Время",
    },

    create: {
      warning:
        "Внимательно прочитайте текст. После создания уведомления, изменить его будет <span>невозможно.</span>",
      shop: "Выбор торговой точки",
      header: "Текст заголовка",
      message: "Текст сообщения",
      button: "Создать рассылку",
      messageAfterCreate:
        "Рассылка находится в обработке, Ваши пользователи получат push-уведомление в течение 15 минут",
    },
  },

  // Answer moderation
  status: {
    moderation: "Under Moderation",
    confirmation: "Confirmed",
    confirm: "Confirmed",
    reject: "Rejected",
    reject2: "Rejected",
    paid: "Paid",
    active: "Active",
    locked: "Blocked",
    activateProcess: "Activating",
    awaitingPayment: "Awaiting Payment",
    sent: "Sent",
    received: "Received",
    canceled: "Canceled",
    unknown: "Unknown",
    awaitingDocs: "Awaiting Document Upload",
    base: "Basic",
    inProgress: "In Progress",
    completed: "Completed",
    new: "New",
    readyForIssue: "Ready for Issuance",
    issuedToClient: "Issued to Client",
    undefined: "Undefined",
    performed: "Performed",
    inWaiting: "Pending",
  },

  // Table
  table: {
    searchByTable: "Search in Table",
    status: "Status",
    nameStatus: "Status Name",
    percentageAccrual: "Accrual Percentage",
    fullName: "Full Name",
    position: "Position",
    phone: "Phone Number",
    login: "Login",
    number: "Number",
    sum: "Amount",
    customer: "Customer",
    cashback: "Points",
    currency: "Currency",
    dateTime: "Date & Time",
    date: "Date",
    paid: "Paid",
    purchase: "Purchase Amount",
    transaction: "Transaction",
    type: "Type",
    points: "Points",
    name: "First Name",
    visits: "Visit Frequency",
    averageCheck: "Purchase Total",
    birthday: "Birthday",
    age: "Age",
    nameAndSurname: "Last & First Name",
    store: "Trading Point",
    entityName: "Organization Name",
    operationType: "Operation Type",
  },

  // Common text
  common: {
    nodata: "You don't have any trading points yet",
    buttonNoData: "Create a trading point",
    organizationSelect: "Select an organization",
    allOrganizationCheckbox: "",
    tradingPointsSelect: "Select a trading point",
    allTradingPointsCheckbox: "All trading points",
    from: "from",
    util: "to",
    to: "to",
    fillField: "Fill in this field",
    invalidEmail: "Invalid email",
    minLengthPass: "Password must be at least 8 characters",
    fillTime: "Fill in the time",
    calendar: "Calendar",
    filter: "Filter",
    filters: "Filters",
    back: "Back",
    loadDescription: "Please upload the product Halal certificate:",
    loadFormat: "Supported formats: .PDF .JPG .PNG",
    loadSize: "File size must not exceed 10 MB",
    dropFiles: "Drag the file here or",
    uploadFiles: "upload",
    chooseFile: "Choose file",
    fileName: "File name",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    Sunday: "Sunday",
    MondayShort: "Mon",
    TuesdayShort: "Tue",
    WednesdayShort: "Wed",
    ThursdayShort: "Thu",
    FridayShort: "Fri",
    SaturdayShort: "Sat",
    SundayShort: "Sun",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
    7: "Sunday",
    dayAndNightTime: "Open 24/7",
    notWorkTime: "Closed",
    month: "month",
    mo: "mo",
    year: "year",
    organizations: "Organizations",
    shops: "Trading points",
    employees: "Cashiers",
    managers: "Managers",
    manager: "Manager",
    owner: "Owner",
    business: "Business",
    tariffs: "Tariffs",
    historyOperations: "Transaction history",
    actsAndAccounts: "Acts & Accounts",
    cashback: "Points accrual",
    documents: "Documents",
    addBalance: "Advance payment",
    addPoints: "Add points",
    application: "Cash register payment",
    claims: "Requests",
    analytics: "Analytics",
    sortNew: "Newest",
    sortAscStars: "Descending stars",
    sortDscStars: "Ascending stars",
    email: "Email",
    lastName: "Last name",
    firstName: "First name",
    error404: "Error 404",
    noPage: "Page not found",
    errorTypeFile: "Invalid file type!",
    tryTypeFile: "File must be jpg or png",
    clients: "Clients",
    exitAccount: "Log out",
    accountsForAct: "Account for act",
    downloadOn: "available on",
    downloadOnRuStore: "download from",
    phone: "Phone",
    comment: "Comment",
    pcs: "pcs",
    gb: "GB",
    min: "min",
    group: "Group",
    emptyField: "Fill in all fields",
    correctField: "All fields must be correct!",
    bigFile: "File size too large",
    "e-menu": "E-menu",
    "document-laboratory": "Document laboratory",
    changesNotSaved: "Changes were not saved",
    statuses: "Statuses",
    phoneNumber: "Phone number",
    mail: "Email",
    tgBot: "Telegram bot",
  },

  // Buttons
  button: {
    invite: "Invite",
    download: "Download",
    edit: "Edit",
    save: "Save",
    saveChange: "Save changes",
    saveAndQuit: "Save and exit",
    accept: "Accept",
    change: "Change",
    login: "Login",
    create: "Create",
    confirm: "Confirm",
    details: "Details",
    copy: "Copy",
    topUp: "Top up",
    back: "Back",
    send: "Send",
    sendAgain: "Send again",
    sendCode: "Send code",
    next: "Next",
    proceed: "Proceed",
    buy: "Buy",
    goto: "Go to",
    open: "Open",
    delete: "Delete",
    cancel: "Cancel",
    cancel2: "Cancel",
    yesCancel: "Yes, cancel",
    yesQuit: "Yes, exit",
    yesDelete: "Yes, delete",
    pay: "Pay",
    ok: "OK!",
    cancelClaim: "Cancel request",
    generate: "Generate",
    apply: "Apply",
    applyAndClose: "Apply and close",
    reset: "Reset",
    clearAll: "Clear all",
    calendarButton: {
      today: "Today",
      yesterday: "Yesterday",
      lastWeek: "Last 7 days",
      last30Days: "Last 30 days",
      lastMonth: "Last month",
      thisMonth: "This month",
      lastYear: "Last year",
      thisYear: "This year",
      allPeriod: "All period",
      selectRange: "Custom range",
    },
    preview: "Preview",
    resetAll: "Reset all",
    showResult: "Show results",
    upload: "Upload",
    expand: "Expand",
    hide: "Hide",
    try: "Try",
    add: "Add",
    reveal: "Show",
    readAll: "Read all",
    collapse: "Collapse",
    logout: "Logout",
    show: "Show",
    moreDetails: "More details",
    settings: "Settings",
    rollUp: "Collapse",
    toTariffs: "To tariffs",
    forModeration: "For moderation",
    quitWithoutSaving: "Exit without saving",
    downloadInvoice: "Download invoice",
    notNow: "Not now",
    createCashier: "Create cashier",
    clearly: "Got it",
    toEdit: "To edit",
    skip: "Skip",
    backAndSave: "Back and save",
    done: "Done",
    close: "Close",
  },

  month: {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  },

  charts: {
    pointsAccrued: "Points accrued",
    pointsWritten: "Points debited",
  },

  eMenu: {
    noData: {
      title: "No data for e-menu",
      noTradingPoints: "You don’t have any trading points yet",
      noProducts: "You haven’t created any products yet",
    },
  },

  validationErrors: {
    emptyField: "Field cannot be empty",
    invalidEmailFormat: "Enter an email like {email}",
    invalidSiteFormat: "URL must contain http:// or https://",
    invalidFormat: "Invalid format",
    incorrectValueStart: "Value must be at least",
    incorrectValueEnd: "up to",
    invalidValueMaxLength: "Maximum number of characters ",
    invalidValueMinLength: "Minimum number of characters ",
    invalidHouseNumber: "Please specify the house number",
    invalidAddress: "Please specify the address",
    invalidWorkDays: "At least one working day must be selected",
    invalidWorkTime: "Invalid time format",
    errorWorkTime:
      "Opening time cannot be later than closing time or equal to it",
    notEnoughElement: "Not enough elements",
    manyElement: "You have exceeded the maximum number of elements",
    maxLessMin: "Less than minimum",
    invalidAge: "Invalid age",
    minDate: "Date must not be later than {date}",
    maxDate: "Date must not be earlier than {date}",
    requiredPhone: "Enter phone number",
    reqiredPromocode: "Promo code is incorrect",
    requiredCountry: "Country selection is required",
    havePhone: "This phone number is already registered",
    haveMail: "This email is already registered",
    invalidEmail: "Invalid email",
    email: "Enter email",
    first_name: "Enter first name",
    last_name: "Enter last name",
    password: "Enter password",
    corresp_account: "Correspondent account is required",
    number_account: "Account number is required",
    commercial_account_number:
      "Account must belong to a legal entity or individual entrepreneur",
    bik_of_bank: "Bank BIC is required",
    mfo_of_bank: "Bank MFI must be specified",
    international_bank: "International bank account number is required",
    vat_code: "VAT code is required",
    inn: "INN is required",
    entityAddress: "Legal address is required",
    fullName: "Full name is required",
    ogrn: "OGRN is required",
    monthly_turnover: "Monthly turnover is required",
    deposit_sum: "Deposit amount is required",
    tax_system: "Tax system is required",
    legal_type: "Legal entity type is required",
    okved_code: "Primary activity code is required",
    minFillingPhotos: "Minimum number of files is {amount}",
    notValidPromocode: "Promo code does not exist",
    cyrillicOnly: "Only Cyrillic and Latin letters allowed",
    haveInn: "A legal entity with this {option} already exists",
    addressWithoutNumber: "Building/unit number must be specified",
    login: "Enter login",
    empryNamedField: "{option} is required",
    passwordMismatch: "Passwords do not match",
    address: "Address with building/unit number is required",
    fieldLengthFromTo: "Field must contain from {from} to {to} digits",
    necessaryEnterMinChars: "At least {minChars} characters required",
    workHours: "Specify working hours for selected days",
    timeFormat: "Invalid time format",
    minImagesUpload: "Upload at least {minImages} images",
    wrongMailOrPassword: "Incorrect email or password",
    wrongLoginOrPassword: "Incorrect login or password",
  },

  promotions: {
    title: "Акции",
    createNewPromo: "Создать новую акцию",
    headersList: {
      name: "Название акции",
      tradingPoint: "Торговая точка",
      cashback: "Процент начисления",
      discount: "Процент скидки",
    },
    name: "Название акции",
    cashback: "Процент начисления",
    discount: "Процент скидки",
    createTitle: "Создание новой акции",
    aboutPageModal: {
      title: "Функционал подраздела “Акции”",
      body:
        'Подраздел "Акции" помогает проводить товары с разным значением скидки и разным значением начисления' +
        "вознаграждения. Для того чтобы создать акцию, нажмите соответствующую кнопку в подразделе “Акции“, затем," +
        " в всплывающем окне укажите торговую точку, название акции, процент начисления и процент скидки.\n" +
        "После успешного создания акции, зайдите как сотрудник в RC Кассу и нажмите на иконку всплывающего " +
        "меню в правом верхнем углу смартфона. Нажав на кнопку “Акции“, выберите созданную в кабинете акцию и " +
        "проведите стандартную операцию списания или начисления баллов.",
    },
    delete: "Вы уверены, что хотите удалить ",
    editTitle: "Редактор акций",
    deleteTitle: "Удалить акцию",
    activate: "Активировать акцию",
    deactivate: "Деактивировать акцию",
    noPromotions: "У вас еще нет акций",
    createWarning: "*До трёх активированных акций на одну торговую точку",
  },

  tooltips: {
    registration: {
      deposit:
        "The minimum account balance. The amount that remains on the balance when withdrawing funds.",
    },
  },

  globalMessagesButton: {
    newTradingPointPage: "Перейти в новый подраздел “Торговые точки”",
    "clients-update": "Попробовать",
    "product-release": "Попробовать",
    "review-update-release": "Попробовать",
  },

  declinationHelperWords: {
    years: [" years", " year", " years"],
    days: [" days", " day", " days"],
    grades: [" grades", " grade", " grades"],
    symbols: [" characters", " character", " characters"],
    result: [" results", " result", " results"],
    review: [" reviews", " review", " reviews"],
    star: [" stars", " star", " stars"],
    clients: [" clients", " client", " clients"],
    product: [" products", " product", " products"],
    entities: [" legal entities", " legal entity", " legal entities"],
  },

  noData: {
    title: "No data",
    emptyHistory: "Your history is empty",
  },

  mobileFiltersName: {
    "trading-points": "Trading Points",
    category: "Category",
    "product-status": "Product Status",
    "review-status": "Review Type",
    sort: "Sorting",
    date: "Period",
  },

  debt: {
    title: "Debt",
    text:
      "Pay it using the invoice sent to your email, or create one yourself\n" +
      "in the “Balance” section",
    link: "Go to payment",
    message:
      "You need to pay the debt of {debt}&nbsp;{currency} <br>" +
      "Payment can be made in one of two ways: create an invoice in your account or download the one sent to your email.",
  },

  permissions: {
    analytics: "Analytics",
    "legal-entity": "Legal entities",
    "trading-point": "Trading points",
    employee: "Cashiers",
    document: "Documents",
    tariff: "Tariffs",
    operation: "Transaction history",
    "act-and-receipt": "Acts and invoices",
    manager: "Managers",
    cashback: "Points accrual",
    balance: "Balance",
    points: "Cashier points",
    // 'claim': 'claim',
    client: "Client list",
    spread: "Wallet card distribution",
    "wallet-pass": "Wallet card design",
    review: "Reviews",
    // 'application': 'application',
    "noncash-tips": "Cashless tips",
    "check-counterparties": "Counterparty verification",
    "push-notifications": "Push notifications",
    // 'group': 'Points accrual (client groups)',
    "client-portrait": "Client profile",
    "active-wait": "Points accrual (Active waiting)",
    "e-menu": "Electronic menu",
    "tg-notifications": "Telegram notifications",
    faq: "FAQ",
    terminal: "Processing",
    promotion: "Promotions",
    cashback_group: "Points accrual (Client groups)",
    payment_info: "Payment methods",
    orders: "Orders",
    "trading-point-promotion": "Promotion",
    "gift-card": "Gift cards",
  },

  promotionServices: {
    servicesList: {
      "xxl-tag": {
        name: "XXL card size",
        description:
          "Increase the size of your venue's card and place a 'Top spot' badge on it",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Your venue's card will be enlarged and highlighted with a 'Top spot' badge on the 'Venues' page on rcpay.ru and in the RC PAY mobile app within the city and category it belongs to.</p></li>" +
          "<li><span>●</span><p>Placement duration – 1 week, 1 month, or 3 months from the moment of order placement and payment in the partner cabinet.</p></li>" +
          "<li><span>●</span><p>You can select the placement duration during the order process.</p></li>" +
          "<li><span>●</span><p>When ordering this service, you also receive a special mark of your venue on the map as a gift.</p></li>" +
          "</ul>",
      },
      tag: {
        name: "Top spot badge",
        description:
          "Place a 'Top spot' badge on your venue's card and move it higher in the general list",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Your venue's card will be highlighted with a 'Top spot' badge and moved higher in the list on the 'Venues' page on rcpay.ru and in the RC PAY mobile app within the city and category it belongs to.</p></li>" +
          "<li><span>●</span><p>Placement duration – 1 week, 2 weeks, 1 month, or 3 months from the moment of order placement and payment in the partner cabinet.</p></li>" +
          "<li><span>●</span><p>You can select the placement duration during the order process.</p></li>" +
          "<li><span>●</span><p>When ordering this service, you also receive a special mark of your venue on the map as a gift.</p></li>" +
          "</ul>",
      },
      top: {
        name: "Top 1 or 2 spot",
        description:
          "Place your venue's card in the 1st or 2nd spot in the list (without changing its appearance or size)",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Your venue's card will be placed in the 1st or 2nd spot on the 'Venues' page on rcpay.ru and in the RC PAY mobile app within the city and category it belongs to.</p></li>" +
          "<li><span>●</span><p>Placement in the 1st or 2nd spot is determined by the order and payment sequence of this service.</p></li>" +
          "<li><span>●</span><p>Placement duration – 2 weeks from the moment of order placement and payment in the partner cabinet.</p></li>" +
          "<li><span>●</span><p>When ordering this service, you also receive a special mark of your venue on the map as a gift.</p></li>" +
          "</ul>",
      },
      hint: "At the moment, all available slots for this service in your trading point's city are occupied. Ordering will be possible from the specified date.",
    },
    periodsList: {
      "7 days": "1 week",
      "14 days": "2 weeks",
      "30 days": "1 month (30 days)",
      "90 days": "3 months (90 days)",
    },
  },
};
